import BaseRepository from '@/api/BaseRepository';
import Revision from '@/models/Revision';

export default class RevisionRepository extends BaseRepository {

    private revisionRoute = 'revision';

    public async getAllRevisions(projectId: string): Promise<any> {
        return this.axiosClient.get(`${this.revisionRoute}?project=${projectId}`);
    }

    public async getRevision(revisionId: string): Promise<any> {
        const mm = this.axiosClient.get(`${this.revisionRoute}/${revisionId}`);
        return mm;
    }

    public async createRevision(payload: Revision): Promise<any> {
        // Make the API request to create the revision
        return this.axiosClient.post(`${this.revisionRoute}`, payload);
        // Return the newly created revision
    }

    public async deleteRevision(revisionId: string): Promise<Revision> {
        return this.axiosClient.delete(`${this.revisionRoute}/${revisionId}`);
    }

    public async getModelDisplacement(revisionId: string): Promise<any> {
        return this.axiosClient.get(`${this.revisionRoute}/${revisionId}/model-displacement`);
    }
}
